import { useRef, useEffect } from 'react';

export const useStableFn = (fn) => {
  const fnRef = useRef(fn);

  useEffect(() => {
    fnRef.current = fn;
  }, [fn]);

  return fnRef.current;
};
